import styled from 'styled-components'

export const Icon = styled.svg`
  flex-shrink: 0;

  ${({ size, color, theme }) => `
    width: ${size}px;
    height: ${size}px;
    color: ${theme.colors[color]};
  `}
`
